import React from "react";
import { Outlet } from "react-router-dom";

import LoadingComponent from "./Loading";
import ViewportContainer from "./Viewport";

import { useLoadingStore, useModalStore } from "../stores/hooks";

const WhatIsMuui = () => {
  return (
    <div className="hidden lg:block bg-white p-12 fixed right-[calc((100vw-736px)/2-180px)] w-160 bottom-30 rounded-8 z-[100]">
      <img src="/assets/images/qrcode.png" alt="QR코드" className="w-80 mb-8" />
      <h5 className="text-gray-0 text-14 font-bold leading-[20px] tracking-[0.014px] mb-8">
        턱 없는 세상을 만드는
        <br />
        무의가 궁금하다면?
      </h5>
      <p className="text-gray-1 text-12 leading-[20px] tracking-[0.03px]">
        QR코드를 스캔해보세요
      </p>
    </div>
  );
};

function Layout() {
  const { loading } = useLoadingStore().state;
  const { modals } = useModalStore().state;

  return (
    <ViewportContainer>
      <div className="min-h-screen bg-gray-1">
        <div className="max-w-[736px] mx-auto w-full bg-white">
          <Outlet />
        </div>

        {loading && <LoadingComponent />}
        {modals?.map((modal) => modal)}
        <WhatIsMuui />
      </div>
    </ViewportContainer>
  );
}

export default Layout;
